import singleStoreMap from "../modules/singleStoreMap";

export default {
  init: function () {
    singleStoreMap();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-store.js